import React, { useEffect, useRef, useState } from 'react';
import { fontReport } from '../../../../apis/util';
import { PRINT_WIDTH } from '..';

export const EUGreenDeal = () => {
    const text = "Climate change and environmental degradation are an existential threat to Europe and the world. To overcome these challenges, the European Green Deal will transform the EU into a modern, resource-efficient and competitive economy. ensuring:\n\nno net emissions of greenhouse gases by 2050\neconomic growth decoupled from resource use\n no person and no place left behind\nThe European Green Deal is also our lifeline out of the COVID-19 pandemic. One third of the €1.8 trilling investments from the NextGenerationEU Recovery Plan, and the EU's seven-year budget will finance the European Green Deal\n\nThe European Commission has adopted a set of proposals to make the EUs climate, energy, transport and taxation plicies fit for reducing net greenhouse gas emissinos by at least 55% by 2030, compared to 1990 levels. More information on Delivering the European Green Deal. (commission.europa.eu/)";
    const ref = useRef();
    const [width, setWidth] = useState(0);
    useEffect(() => {
        if (!ref.current) return;
        const resizeObserver = new ResizeObserver(() => {
            setWidth(ref.current.clientWidth);
        });
        resizeObserver.observe(ref.current);
        return () => resizeObserver.disconnect();
    }, []);
    return (
        <div className="eugreendeal" ref={ref}>
            <h2 style={{ fontSize: fontReport(width,PRINT_WIDTH,51/PRINT_WIDTH,"px")}}>E.U Green Deal</h2>
            <div className="page__body" style={{marginTop:"9%",fontStyle:"italic"}}>
                <h5 style={{ lineHeight: "1.6",fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem")}}>{text}</h5>
            </div>
        </div>
    );
};